import Modal from 'components/commons/modal/Modal2';
import React, { useEffect, useState } from 'react';
import { initializeScrolTop } from 'utils/dom';

export const ShareModal = ({
  hide,
  goBack,
  isShow,
  icon,
  name,
  onChangeSNSAccount,
  onCancel,
  onShare,
}: {
  isShow: boolean;
  hide: () => void;
  goBack: () => void;
  icon: string;
  name: string;
  onChangeSNSAccount: () => void;
  onShare: () => Promise<{ tag: 'NotFoundDataURL' | 'Success' | 'Failure' }>;
  onCancel: () => void;
}): React.ReactElement => {
  const [state, setState] = useState<
    'Ready' | 'Hitting' | 'NotFoundDataURL' | 'Succeeded' | 'Failed'
  >('Ready');
  useEffect(() => {
    if (state === 'Succeeded') {
      setTimeout(goBack, 1000);
      initializeScrolTop();
    }
  }, [state, goBack]);
  return (
    <>
      <Modal
        {...{
          isShow,
          close: hide,
          closeOnClickOutsideWindow: true,
        }}>
        <div className="p-4">
          <div className="flex flex-row">
            <div
              className="ml-auto icon-close text-md cursor-pointer"
              onClick={hide}></div>
          </div>
          <div className="flex flex-row mt-2 font-bold text-lg text-bluegray-700">
            以下のアカウントでシェアします
          </div>
          <div className="flex flex-row font-bold mt-4 border-b border-t border-bluegray-300 py-2 items-center">
            <img
              className="w-14 h-14 rounded-full mr-2"
              src={icon}
              alt="アイコン"></img>
            <div className="text-md">{name}</div>
          </div>
          <div className="flex flex-row items-center mt-4">
            <div
              className="ml-auto text-blue-700 cursor-pointer"
              onClick={onChangeSNSAccount}>
              SNSアカウントを切り替える
            </div>
          </div>
          <div className="p-4 flex flex-col gap-4 mt-4">
            {state === 'Failed' && (
              <div className="text-sm mt-2 text-bluegray-500">
                失敗しました。再試行してください。
              </div>
            )}
            {state === 'Hitting' && (
              <div className="bg-white flex flex-row items-center justify-center">
                <img
                  src="/static/images/loading/spin-gray.svg"
                  alt="ローディング"
                />
              </div>
            )}
            {state === 'Succeeded' && (
              <>
                <div className="bg-white flex flex-row items-center justify-center">
                  <div className="icon-check text-teal-600 text-2xl"></div>
                </div>
              </>
            )}
            <button
              className="bg-tradewell rounded-lg font-bold text-white p-2 overflow-hidden"
              onClick={async (): Promise<void> => {
                setState('Hitting');
                const ret = await onShare();
                setState(
                  ((): typeof state => {
                    switch (ret.tag) {
                      case 'Failure':
                        return 'Failed';
                      case 'NotFoundDataURL':
                        return 'NotFoundDataURL';
                      case 'Success':
                        return 'Succeeded';
                    }
                  })()
                );
              }}>
              はい
            </button>
            <button className="bg-white rounded-lg p-2" onClick={onCancel}>
              キャンセル
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};
